import { Menu as BaseMenu } from "@base-ui/react/menu";
import type { MenuItemProps } from "..";
import { useMenuLink } from "../menuLinkContext";
import { searchItemStylesClass } from "./styles.css";

interface MenuSearchItemProps {
  subsubitem: MenuItemProps;
  parentPath: string;
}

export const MenuSearchItem = ({
  subsubitem,
  parentPath,
}: MenuSearchItemProps) => {
  const LinkComponent = useMenuLink();
  const pathToGo = subsubitem.overridePath || parentPath + subsubitem.path;

  return (
    <BaseMenu.Item
      id={`menu-item-${subsubitem.id}`}
      render={
        <LinkComponent
          to={pathToGo}
          href={pathToGo}
          className={searchItemStylesClass}
        >
          {subsubitem.searchText}
        </LinkComponent>
      }
      closeOnClick={true}
    >
      {subsubitem.searchText}
    </BaseMenu.Item>
  );
};
